import React, { Component } from 'react';
import WriteButton from './WriteButton';
import GenerateButton from './GenerateButton';
import Space from './Space';
import TopBar from './TopBar';
import WritingPrompt from './WritingPrompt';
import { PromptContext } from './AppContext';
import SegmentTracker from './SegmentTracking';
import Footer from './Footer';


export default class Welcome extends Component {

  constructor(props) {
    super(props);

    const url = 'https://www.squibler.io/api/v1/random-prompt-generator';
    this.scrollToTop = this.scrollToTop.bind(this);

    this.segmentTracker = new SegmentTracker(window);
    this.segmentTracker.trackPage('Loaded TMDWP Start Page');

    localStorage.removeItem('promptContent');

    this.changePromptContent = () => {

      this.setState({
        promptContent: undefined,
        selectedPromptId: -1,
      });

      this.state.showGenerator = false;

      const idsList = this.state.idsList;
      let newId = idsList[Math.floor(Math.random() * idsList.length)];

      if (newId !== undefined)
        fetch(`${url}/${newId}/`)
          .then(res => res.json())
          .then(
            (result) => {
              const { prompt_content, id } = result;
              this.setState({
                promptContent: prompt_content,
                selectedPromptId: id
              });
              localStorage.setItem('promptContent', prompt_content)
            },
            (error) => {
              this.setState({
                promptContent: "--- ERROR ---",
                error
              });
            }
          )
    }

    this.loadPromptIds = () => {
      return fetch(`${url}/ids/`)
        .then(res => res.json())
        .then(
          (result) => {
            // const idsList = result.data;
            const idsList = result;
            this.setState({
              idsList,
            }, () => {
              this.changePromptContent()
            });
          },
          (error) => {
            this.setState({
              error
            });
          }
        )
    }

    this.toggleGenerator = () => {
      this.setState({
        promptContent: "",

      })
      this.changePromptContent();
      this.state.showGenerator = true;
    }

    this.generatePromptEvent = () => {
      this.segmentTracker.trackEvent('Generate New Prompt');
      this.state.showGenerator = true;
    }

    fetch(`${url}/ids/`)
      .then(res => res.json())
      .then(
        (result) => {
          const idsList = result;
          this.setState({
            idsList,
        },() => {
            this.changePromptContent()
        });
        },
        (error) => {
          this.setState({
            error
          });
        }
      )

    this.state = {
      idsList: [],
      promptContent: "",
      selectedPromptId: -1,
      showGenerator: false,
      changePromptContent: this.changePromptContent,
      generatePromptEvent: this.generatePromptEvent
    };

    this.segmentTracker = new SegmentTracker(window);
    this.segmentTracker.trackPage('Loaded TMDWP Prompt Page');
  }


  scrollToTop() {
    this.segmentTracker.trackEvent('Lets Go TMDWA Page Bottom');
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="Welcome non-fixed">
        <div className="Welcome non-fixed">
          <TopBar />
          <Space l hide-680 />
          <div>
            <div className="logo">
              <h1>
                Plot Generator with 500+ Short Story Ideas
            </h1>
            </div>
            <Space xs />
            <h2>
              Start writing with our random writing prompts.
          </h2>
            <Space xs />
            <Space l hide-600 />
            <div className="buttons-wrapper">
              {this.state.showGenerator ?
                <PromptContext.Provider value={this.state}>
                  <PromptContext.Consumer>{({ changePromptContent, idsList, generatePromptEvent }) =>
                    <GenerateButton ghost
                      changePromptContent={changePromptContent}
                      idsList={idsList}
                      generatePromptEvent={generatePromptEvent}
                      label="Generate New Prompt" />
                  }
                  </PromptContext.Consumer>
                </PromptContext.Provider>
                :
                <div className="writeButton" onClick={this.toggleGenerator}>
                  <a className="ghost">Generate a Prompt</a>
                </div>
              }
              {
                this.state.showGenerator ?
                  <WriteButton ghost label="Start Writing" color="red" rootPageName="Promp Page" />
                  :
                  <div className="writeButton">
                    <a className="ghost red" href="https://www.squibler.io/dangerous-writing-prompt-app">Try Dangerous Mode</a>
                  </div>
              }
            </div>

            {this.state.showGenerator ?
              <div>
                <Space m hide-600 />
                <PromptContext.Provider value={this.state}>
                  <PromptContext.Consumer>{({ changePromptContent, selectedPromptId, promptContent }) =>
                    <div>
                      <div className="writing-prompt-list" >
                        <WritingPrompt
                          key={selectedPromptId} index={selectedPromptId} text={promptContent}
                          selected={false}
                          changePromptContent={changePromptContent}
                        />
                      </div>
                    </div>
                  }
                  </PromptContext.Consumer>
                </PromptContext.Provider>
              </div>
              : null}
          </div>
          <Space xl />
          <div className="accolades">
            <img className="accolades-full" src={require('../images/logos.png')} alt="accolades" />
            <span className="accolades-p0 as-seen-in">as seen in</span>
            <img className="accolades-p1" src={require('../images/logos_1p.png')} alt="accolades" />
            <img className="accolades-p2" src={require('../images/logos_2p.png')} alt="accolades" />
            <img className="accolades-p3" src={require('../images/logos_3p.png')} alt="accolades" />
          </div>
          <Space l with-bottom-shadow />
          <div className="examples with-bottom-shadow">
            <h2 className="main-title logo">A Writing Prompt Generator with Story Ideas</h2>

            <div className="examples-single">
              <div className="examples-content">
                <h2>A First Line Generator that Inspires</h2>
                <p>Over 500+ first line suggestions to get your started with this writing app. You'll never run out of plot ideas.</p>
              </div>
              <div className="examples-image image-1"></div>
            </div>

            <div className="examples-single right">
              <div className="examples-image image-2"></div>
              <div className="examples-content right">
                <h2>A Story Prompt Generator for Everyone</h2>
                <p>Whether you're fiction writing, practicing for your novel, or simply trying to overcome writer's block, this is for you.</p>
              </div>
            </div>

            <div className="examples-single">
              <div className="examples-content">
                <h2>A Creative Random Prompt Generator</h2>
                <p>Get the creative nudge to write with over 500+ random prompts.</p>
              </div>
              <div className="examples-image image-3"></div>
            </div>

            <div className="examples-single right">
              <div className="examples-image image-4"></div>
              <div className="examples-content right">
                <h2>A Random Plot Generator</h2>
                <p>An idea generator to write stories with story line and story plot inspiration or just on a timer. A random plot generator that makes writing easy”</p>
              </div>
            </div>
            <Space l />
          </div>

          <div className="bottom-box">
            <div className="bottom-logo">
              <div className="bottom-logo-image" />
            </div>
            <Space l />
            <div className="logo">
              <h2>
                Writing Exercises for Short Story Ideas
            </h2>
            </div>
            <Space m />
            <div className="buttons-wrapper mb-5 pb-5">
              <div className="writeButton" onClick={this.scrollToTop}>
                <a className="blue">Let's go</a>
              </div>
            </div>
            <Footer mt-4 />
          </div>

        </div>

      </div>
    )
  }
}
